import poster from '@/static/assets/reviews/MarkLevine/video.jpg';
import subs from '@/static/assets/reviews/MarkLevine/subs.vtt';
import { ASSETS_URL, ReviewProduct, ReviewType, VideoReview } from '../../types';

export const MarkLevine: VideoReview = {
  type: ReviewType.Video,
  product: [ReviewProduct.Pet],
  reviewerName: 'Mark',
  videoUrl: `${ASSETS_URL}/pet/MarkLevine_Pet.webm`,
  posterUrl: poster,
  captionsUrl: subs,
};
